import { CostPreference, LanguagePreference } from "@/api/reservation/dto";
import { useRequestReservation } from "@/api/reservation/useRequestReservation";
import { useNavigate } from "react-router-dom";

export function useCompletePortoneReservation() {
  const navigate = useNavigate();
  const { mutateAsync: requestReservation } = useRequestReservation();

  const completeReservation = async (paymentId: string) => {
    const pendingReservationData = sessionStorage.getItem("pendingReservation");

    if (!pendingReservationData) {
      throw new Error("예약 정보를 찾을 수 없습니다.");
    }

    const reservationData = JSON.parse(pendingReservationData);
    const preferredLocationIds = reservationData.preferredLocationIds.map((id: string) => {
      const locationId = Number(id);
      if (!Number.isInteger(locationId)) {
        throw new Error("선택한 장소 정보를 확인할 수 없습니다.");
      }
      return locationId;
    });

    await requestReservation({
      reservationDetails: {
        preferredLocationIds,
        preferredTimes: reservationData.preferredTimes,
        messageForGuests: reservationData.messageForGuests,
      },
      dinnerPreference: {
        preferredLanguage: reservationData.dinnerPreference.preferredLanguage as LanguagePreference,
        preferredCost: reservationData.dinnerPreference.preferredCost as CostPreference,
        dietaryRestrictions: reservationData.dinnerPreference.dietaryRestrictions,
        dietaryRestrictionsOtherText: reservationData.dinnerPreference.dietaryRestrictionsOtherText,
      },
      paymentId,
      amount: 12000,
    });

    sessionStorage.removeItem("pendingReservation");
    navigate("/event-confirmation");
  };

  return { completeReservation };
}
